<template>
  <div>
    <XVSticky>
      <div class="btn-group">
        <button type="button" id="btnverstuur" class="btn btn-primary btn-xs" @click="btnverstuur">
          <font-awesome-icon :icon="['far', 'envelope']" />
          {{ translation(29) }}
        </button>
        <button type="button" id="btnterug" class="btn btn-primary btn-xs" @click="btnterug">
          <font-awesome-icon icon="times" />
          {{ translation(17) }}
        </button>
      </div>
    </XVSticky>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(11690) }}</span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblinfo" v-html="translation(11691)"></span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <fieldset>
          <div class="margin20"></div>
          <XVbootstraprow
            id="lblnaam"
            :label="translation(11692)"
            class="margin20"
            :required="true"
            :haserror="errors.has('tbxName')"
            :errormessage="errors.first('tbxName')"
          >
            <XVinput
              id="tbxName"
              name="tbxName"
              v-validate="'required'"
              :data-vv-as="translation(11692)"
              v-model="forminputdata.tbxName"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblgeslacht"
            :label="translation(42)"
            class="margin20"
            :required="true"
            :haserror="errors.has('rbgeslacht')"
            :errormessage="errors.first('rbgeslacht')"
          >
            <XVradiobuttonlistHorizontal
              :datalist="[
                { value: 'M', labelText: translation(39) },
                { value: 'F', labelText: translation(40) },
              ]"
              id="rbgeslacht"
              v-validate="'required'"
              name="rbgeslacht"
              :data-vv-as="translation(42)"
              :formdata="{ tblQuestionShowHeader: false }"
              v-model="forminputdata.rbgeslacht"
            />
          </XVbootstraprow>
          <XVbootstraprow
            id="lbledu"
            :label="translation(11693)"
            class="margin20"
            :required="true"
            :haserror="errors.has('tbxEdu')"
            :errormessage="errors.first('tbxEdu')"
          >
            <XVinput
              id="tbxEdu"
              name="tbxEdu"
              v-validate="'required'"
              :data-vv-as="translation(11693)"
              v-model="forminputdata.tbxEdu"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblEerdereAanvraag"
            :label="translation(11694)"
            class="margin20"
            :required="true"
            :haserror="errors.has('rbEerdereAanvraag')"
            :errormessage="errors.first('rbEerdereAanvraag')"
          >
            <XVradiobuttonlistHorizontal
              :datalist="[
                { value: 'ja', labelText: translation(191) },
                { value: 'nee', labelText: translation(192) },
              ]"
              id="rbEerdereAanvraag"
              v-validate="'required'"
              name="rbEerdereAanvraag"
              :data-vv-as="translation(11694)"
              :formdata="{ tblQuestionShowHeader: false }"
              v-model="forminputdata.rbEerdereAanvraag"
            />
          </XVbootstraprow>
          <XVbootstraprow
            id="lblTelefoon"
            :label="translation(11695)"
            class="margin20"
            :required="true"
            :haserror="errors.has('tbxTelefoon')"
            :errormessage="errors.first('tbxTelefoon')"
          >
            <XVinput
              id="tbxTelefoon"
              name="tbxTelefoon"
              v-validate="'required'"
              :data-vv-as="translation(11695)"
              v-model="forminputdata.tbxTelefoon"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblEmail"
            :label="translation(11702)"
            class="margin20"
            :required="true"
            :haserror="errors.has('tbxEmail')"
            :errormessage="errors.first('tbxEmail')"
          >
            <XVinput
              id="tbxEmail"
              name="tbxEmail"
              v-validate="'required|email'"
              data-vv-validate-on="change"
              :data-vv-as="translation(11702)"
              v-model="forminputdata.tbxEmail"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow id="lblAccrNr" :label="translation(11696)" class="margin20">
            <XVinput id="tbxAccrNr" name="tbxAccrNr" v-model="forminputdata.tbxAccrNr"></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblVraag"
            :label="translation(11697)"
            class="margin20"
            :required="true"
            :haserror="errors.has('tbxVraag')"
            :errormessage="errors.first('tbxVraag')"
          >
            <XVtextarea
              id="tbxVraag"
              name="tbxVraag"
              v-validate="'required'"
              :data-vv-as="translation(11697)"
              v-model="forminputdata.tbxVraag"
            ></XVtextarea>
          </XVbootstraprow>
          <!-- Create field for the honeypot -->
          <XVbootstraprow id="lblextra" :label="translation(11697)" class="margin20">
            <XVtextarea id="tbxextra" name="tbxextra" v-model="forminputdata.tbxextra"></XVtextarea>
          </XVbootstraprow>
          <!-- end honeypot -->
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'

// TEXT-ID 45: Uw bericht is verstuurd naar de helpdesk, zij zullen spoedig contact met u opnemen.
import { mapActions, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
import { sync } from 'vuex-pathify'

// https://pe.xaurum.nl/peapp/public/Spe005PrHelpdesk/edu
export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  async mounted() {
    this.startLoading({ showmessage: false, disablepage: false })
    this.stopLoading()
  },
  computed: {
    forminputdata: sync('Spe005PrHelpdesk/forminputdata'),
  },
  methods: {
    ...mapActions('Spe005PrHelpdesk', ['sendMail']),
    ...mapMutations(['addNotification']),
    btnterug() {
      window.location = '/SPE200_EDU_Inloggen.aspx'
    },
    btnverstuur() {
      this.$validator.validate().then(async (result) => {
        // check if honeypot is still an empty string. if not: probably a bot and api is not fired.
        if (result && this.forminputdata.tbxextra === '') {
          let mailData = {
            Naam: this.forminputdata.tbxName,
            Geslacht: this.forminputdata.rbgeslacht,
            Edu: this.forminputdata.tbxEdu,
            EerdereAanvraag: this.forminputdata.rbEerdereAanvraag,
            AccrNr: this.forminputdata.tbxAccrNr,
            Telefoon: this.forminputdata.tbxTelefoon,
            Email: this.forminputdata.tbxEmail,
            Opmerkingen: this.forminputdata.tbxVraag,
          }
          await this.sendMail(mailData)
          // form wordt weer leeggemaakt in sendMail(). Onderstaande zorgt er voor dat niet meteen alle validators afgaan.
          requestAnimationFrame(() => {
            this.$validator.reset()
          })
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
  },
}
</script>
<style scoped>
#lblextra {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}
</style>
<style>
.public_SPE005PrHelpdesk .stickybar {
  background-color: #fff;
}
</style>
